import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Topbar from "./components/topbar/Topbar";
import Bottombar from "./components/bottombar/Bottombar";
import Homepage from "./pages/homepage/Homepage";
import Praktijk from "./pages/praktijk/Praktijk";
import Consult from "./pages/consult/Consult";
import Tips from "./pages/tips/Tips";
import Adres from "./pages/adres/Adres";
import Contact from "./pages/contact/Contact";

function ScrollToTop() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [location.pathname]);

    return null;
}

function AppLayout() {
    return (
        <>
            <ScrollToTop />
            <Topbar />
            <main className="site-main">
                <Switch>
                    <Route exact path="/" component={Homepage} />
                    <Route exact path="/praktijk" component={Praktijk} />
                    <Route exact path="/consult" component={Consult} />
                    <Route exact path="/tips" component={Tips} />
                    <Route exact path="/adres" component={Adres} />
                    <Route exact path="/contact" component={Contact} />
                </Switch>
            </main>
            <Bottombar />
        </>
    );
}

export default function App() {
    return (
        <Router>
            <AppLayout />
        </Router>
    );
}
